import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import { toast } from "react-toastify";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";
class ChartCustomization extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widget: this.props.widget,
            widgetInfo: this.props.widgetInfo,
            matrixOption: this.props.excludeEngagmentMatrix,
        };
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.excludeEngagmentMatrix && prevProps.excludeEngagmentMatrix !== this.props.excludeEngagmentMatrix) {
    //         if (this.props.excludeEngagmentMatrix.length == 4) {
    //             // this.props.updateEngagementMatrix(["selectAll"]);
    //         }
    //     }
    // }

    getMatrixOptions = () => {
        return [
            { key: "all", text: "Exclude None", value: "selectAll" },
            { key: "like", text: "Exclude Likes", value: "like_count" },
            { key: "comment", text: "Exclude Comments", value: "comment_count" },
            { key: "share", text: "Exclude Shares", value: "share_count" },
            { key: "view", text: "Exclude Views", value: "view_count" },
        ];
    };

    save = async () => {
        await this.props.updateEngagementMatrix(this.state.matrixOption);
        await this.props.updateChartCustomizationSettings({ widget: this.state.widget });
    };

    closeModal = () => {
        this.setState({ matrixOption: this.props.excludeEngagmentMatrix });
        this.props.onClose();
        // this.setState({ excludeViews: this.props.widget.widget_filter?.excludeViews });
    };

    changeValue = (val) => {
        if (val === "selectAll") {
            this.setState({ matrixOption: ["selectAll"] });
        } else {
            if (this.state.matrixOption[0] === "selectAll") this.setState({ matrixOption: [val] });
            else if (this.state.matrixOption.includes(val)) this.setState({ matrixOption: this.state.matrixOption.filter((v) => v !== val) });
            else {
                this.setState((prevState) => ({
                    matrixOption: [val, ...prevState.matrixOption],
                }));
            }
        }
    };

    render() {
        const priortyOptions = this.getMatrixOptions();
        return (
            <Modal className={`chart-config-modal`} show={this.props.showChartSettings} onClose={() => this.closeModal()}>
                <Modal.Header>Exclude Metrics</Modal.Header>
                <Modal.Content className="chart-customization-content">
                    {priortyOptions.map((o) => (
                        <div className="filter-list-item" key={o.key}>
                            <Checkbox checked={this.state.matrixOption?.includes(o.value)} onChange={() => this.changeValue(o.value)} label={o.text} />
                        </div>
                    ))}
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.closeModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={this.save}>
                        Save
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default ChartCustomization;
